import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import { composedAPI } from "./api";
import internetComposition from "./composition";
import help from "help/viewInternetProfileConfig.md";
import settingsHelp from "help/viewInternetProfileConfigSettings.md";

const ConfigInternetProfiles = ({ ...settings }) => (
  <ProfilesAndSettings
    {...internetComposition}
    {...composedAPI}
    {...settings}
    help={help}
    settingsHelp={settingsHelp}
  />
);

export default ConfigInternetProfiles;
